import { render, staticRenderFns } from "./ExchangeDetail.html?vue&type=template&id=06902e6c&scoped=true&"
import script from "./ExchangeDetail.js?vue&type=script&lang=js&"
export * from "./ExchangeDetail.js?vue&type=script&lang=js&"
import style0 from "./ExchangeDetail.scss?vue&type=style&index=0&id=06902e6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06902e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow})
